import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedMovies from './components/FeaturedMovies';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import FeaturesHighlight from './components/FeaturesHighlight';
import NewsletterSection from './components/NewsletterSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '天堂影院',
  url: 'https://tiantangcinema.com',
  description: '天堂影院主打高清不缓冲流畅在线观看，无广告影视极速播放，蓝光画质享受，免费在线看大片。汇聚电影大全高清影视在线播放，观影不卡顿。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://tiantangcinema.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '天堂影院',
  url: 'https://tiantangcinema.com',
  description: '高清不缓冲，流畅在线观看。无广告影视，极速播放，蓝光画质享受。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@tiantangcinema.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="高清不缓冲 流畅在线观看 - 无广告影视 极速播放 蓝光画质"
        description="天堂影院主打高清不缓冲流畅在线观看，无广告影视极速播放，蓝光画质享受，免费在线看大片。汇聚电影大全高清影视在线播放，观影不卡顿。"
        keywords="天堂影院,高清不缓冲,流畅在线观看,无广告影视,极速播放,蓝光画质,免费在线看大片,高清影视在线播放,电影大全,不卡顿"
        schema={[homeSchema, orgSchema]}
      />

      <main>
        <article>
          <HeroSection />
          <FeaturedMovies />
          <CategoryGrid />
          <LatestUpdates />
          <FeaturesHighlight />
          <NewsletterSection />
        </article>
      </main>
    </>
  );
}